import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import SelectField from 'forms/shared/fields/select'

export const classficationOptions = [
  {
    value: 'grade-a',
    name: 'Grade A',
    label: 'Grade A',
  },
  {
    value: 'grade-b',
    name: 'Grade B',
    label: 'Grade B',
  },
  {
    value: 'grade-c',
    name: 'Grade C',
    label: 'Grade C',
  },
  {
    value: 'grade-d',
    name: 'Grade D',
    label: 'Grade D',
  },
  {
    value: 'grade-bp',
    name: 'Grade B+',
    label: 'Grade B+',
  }, {
    value: 'shop-house',
    name: 'Shop House',
    label: 'Shop House',
  }, {
    value: 'business-parks-industrial-logistics',
    name: 'Business Parks - Industrial & Logistics',
    label: 'Business Parks - Industrial & Logistics',
  }
]
const FilterClassification = ({ customStyles }) => {
  return (
    <div className={`multi-select-filter border-l border-gray-300 w-48 text-xs`}>
      <Field
        styles={customStyles}
        name="building_classification_filter"
        placeholder="Building Classfication"
        options={classficationOptions}
        component={SelectField}
      ></Field>
    </div>
  )
}

FilterClassification.propTypes = {
  customStyles: PropTypes.object,
}

export default FilterClassification
